import { useQuery } from '@tanstack/react-query'

const fetchSolanaConfig = async (mimicId) => {
  if (!mimicId) return []

  const response = await fetch(`https://api.mimic.fi/public/solana/client/${mimicId}`)
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }
  
  const data = await response.json()
  // Ensure we always return an array
  return Array.isArray(data) ? data : [data]
}

const useSolanaConfig = (mimicId) => {
  return useQuery({
    queryKey: ['solana-config', mimicId],
    queryFn: () => fetchSolanaConfig(mimicId),
    enabled: !!mimicId,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 3
  })
}

export default useSolanaConfig